import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/components/common/api';
import { Service } from '../../../models/service.model';
import { ServiceTypeService } from '../../../services/service-type/service-type.service';
import { ServiceService } from '../../../services/service/service.service';


@Component({
  selector: 'app-service-form',
  templateUrl: 'serviceForm.html',
  styles: ['label.required:after {top: 0}']
})
export class ServiceFormComponent implements OnInit {
  @Output() endSaveOrUpdate = new EventEmitter<boolean>();
  @Input() dataEdit: Service = null;

  addEditForm: FormGroup;
  serviceTypes: SelectItem[];
  flgDirectActiveList: SelectItem[];
  formReady = false;
  fields: any;
  invalidSubmit: boolean;

  constructor (
    private fb: FormBuilder,
    private srvService: ServiceService,
    private srvServiceType: ServiceTypeService,
    private srvTranslate: TranslateService
  ) { }

  ngOnInit(): void {
    console.log(this.dataEdit);
    this.srvService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.flgDirectActiveList = [
      { label: this.srvTranslate.instant('shoppingList.no'), value: 0},
      { label: this.srvTranslate.instant('shoppingList.yes'), value: 1},
      { label: this.srvTranslate.instant('cluster_ochannel.yesConfirm'), value: 2}
    ]
    this.serviceTypes = [];
    this.srvServiceType.getAll().subscribe(data => {
      data.forEach(c => {
        this.serviceTypes.push({
          value: c.id,
          label: c.name
        });
      });
      let id = this.dataEdit ? new FormControl(this.dataEdit.id) : null;
      let service_type_id = this.dataEdit ? new FormControl('' + this.dataEdit.service_type_id) : null;
      let name = this.dataEdit ? new FormControl(this.dataEdit.name) : '';
      let description = this.dataEdit ? new FormControl(this.dataEdit.description) : '';
      let flg_direct_active = this.dataEdit ? new FormControl(this.dataEdit.flg_direct_active) : '';

      this.addEditForm = this.fb.group({
        id: id,
        service_type_id: service_type_id,
        name: name,
        description: description,
        flg_direct_active:flg_direct_active
      });

      this.formReady = true;
    });
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let data = this.addEditForm.value;
    if (data && data.id) {
      this.srvService.put(data).subscribe();
    } else {
      this.srvService.post(data).subscribe();
    }
    this.endSaveOrUpdate.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/service/serviceForm.component.ts